import { render, staticRenderFns } from "./EducationForm.vue?vue&type=template&id=32ca00aa&scoped=true"
import script from "./EducationForm.vue?vue&type=script&lang=js"
export * from "./EducationForm.vue?vue&type=script&lang=js"
import style0 from "./EducationForm.vue?vue&type=style&index=0&id=32ca00aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ca00aa",
  null
  
)

export default component.exports